import {
  clientCreateApi,
  clientDetailApi,
  clientEditApi,
  clientListApi,
} from "../../core/http/httpClient";
import { makeAsyncApiCall } from "../common";
import { takeEveryFsa } from "../operations";
import { clientActions } from "./actions";

export function* clientSaga() {
  yield takeEveryFsa(clientActions.fetchClients.started, function* (action) {
    yield* makeAsyncApiCall(action, clientActions.fetchClients, clientListApi);
  });

  yield takeEveryFsa(
    clientActions.getClientDetails.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        clientActions.getClientDetails,
        clientDetailApi
      );
    }
  );

  yield takeEveryFsa(clientActions.createNewClient.started, function* (action) {
    yield* makeAsyncApiCall(
      action,
      clientActions.createNewClient,
      clientCreateApi
    );
  });

  yield takeEveryFsa(clientActions.updateClientReadStatus.started, function* (action) {
    yield* makeAsyncApiCall(action, clientActions.updateClientReadStatus, clientEditApi);
  });
}
